import { useState, useEffect, useRef, Fragment } from "react";
import TranslatesContent from "../../DataStore/Languages/translatesContent";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import _ from "lodash";
import axios from "axios";
import { CRYPTOURL, CRYPTO_MERCHANT, DEOSITBONUSURL,} from "../../DataStore/ApiConstant";
import BonusOffer from "../TransactionCommon/BonusOffer";
import { useAtom } from "jotai";
import { bonusStore } from "../../DataStore/atom";
import { getFormData, calculateBonus, calculateTurnover } from "../../utils";
import { useDepositBonus } from "../../services/cashier";
import { useCurrencyRates } from "../../services/cashier";
import { useInrToUsd } from "../../services/config";
import {NumericFormat} from "react-number-format";
import QRupiComponent from "../Modal/GeneralModal/QRupiComponent";
import { IMAGE_BUCKET_URL } from "../../DataStore/ApiConstant";



const currencyRules = [
  { currency: "USD", min: 1, max: 5000 }
];

const getValidatorSchema = () => {
  const { min, max } = currencyRules.find((rule) => rule.currency === "USD");
  return yup.object().shape({
    amount: yup
      .number()
      .min(min, "error-min-amount-in-ballys-crypto")
      .max(max, "error-max-amount-in-ballys-crypto")
      .typeError("error-amount-must-be-number-in-ballys-crypto"),
  });
};


const BallysCryptoWallet = ({ cashierReturnStatus, cashierReturnDepositPill }) => {
  const [BonusStore, setBonusStore] = useAtom(bonusStore);
  const [depositBonus, setDepositBonus] = useState(true);
  const [reBonus, setReBonus] = useState(0);
  const [reTurn, setReTurn] = useState(0);
  const [usd, setUsd] = useState(0);
  const [load, setLoad] = useState(false);

  const [lkrAmount, setLkrAmount] = useState(0);
  const [inrAmount, setInrAmount] = useState(0);

  const [selectedOption, setSelectedOption] = useState(1);

  const [showSuccessMessage, setShowSuccessMessage] = useState(null);
  const [amount, setAmount] = useState(0);
  const [errmsg, setErrmsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loader, setLoader] = useState(false);
  const [paymentErr, setPaymentErr] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const statusMessageRef = useRef(null);

  const schema = getValidatorSchema();
  const { handleSubmit, formState: { errors }, register, reset } = useForm({ resolver: yupResolver(schema) });

  const renderMaybeTranslated = (message) => {
    if (!message) return null;
    if (typeof message !== "string") return message;

    if (message.startsWith("error-") || message.endsWith("-in-ballys-crypto")) {
      return <TranslatesContent contentKey={message} />;
    }

    return message;
  };

  const handleCopyToClipboard = () => {
    const textToCopy = "TXf3Q5mWKF7z373T6Q3spph3jDcv2Hdpx6";
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopySuccess(true);
      setTimeout(() => {
        setCopySuccess(false);
      }, 2000);
    }).catch((err) => {
      console.error('Failed to copy text: ', err);
    });
  };

  useEffect(() => {
    reset();
  }, [reset]);

  useEffect(() => {
    if (cashierReturnDepositPill !== "cryptoBallys") return;
    if (cashierReturnStatus !== "success" && cashierReturnStatus !== "cancel") return;

    setShowSuccessMessage(
      cashierReturnStatus === "success"
        ? "transaction-success-in-ballys-crypto"
        : "transaction-failed-in-ballys-crypto"
    );

    const timer = setTimeout(() => {
      setShowSuccessMessage(null);
    }, 5000);

    return () => clearTimeout(timer);
  }, [cashierReturnStatus, cashierReturnDepositPill]);

  useEffect(() => {
    if (!showSuccessMessage) return;

    const bannerEl = statusMessageRef.current;
    const fallbackPane = document.getElementById("v-pills-cryptoBallys");
    (bannerEl || fallbackPane)?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [showSuccessMessage]);
  return (
    <Fragment>
    <div
      className="tab-pane fade "
      id="v-pills-cryptoBallys"
      role="tabpanel"
      aria-labelledby="v-pills-cryptoBallys-tab"
    >
          <div className="qrpaymentTitelForBallysQr d-flex justify-content-center">
            {/* Scan the QR or copy the wallet address to make payments */}
            <TranslatesContent contentKey="scan-qr-or-copy-wallet-usdt-trc20-in-ballys-crypto" />
          </div>
          <div className="row d-flex justify-content-center visible">
            <div className="col-12 col-md-6">
              <div className="qrpaymentBGForBallysQr d-flex justify-content-center align-items-center">
                <div className=" justify-content-center align-items-center">
                  <img src={IMAGE_BUCKET_URL + "qrBallysCrypto.jpeg"}className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="mb-2">
            <div className="copy-text d-flex justify-content-center flex-column flex-sm-row align-items-center mx-auto" style={{ maxWidth: "300px" }}>
              <input disabled type="text" className="text w-100" defaultValue="TXf3Q5mWKF7z373T6Q3spph3jDcv2Hdpx6" />
              <button onClick={handleCopyToClipboard} className="mt-2 mt-sm-0">
                <i className="fa fa-clone" />
              </button>
            </div>
          </div>
          {copySuccess && (
            <div className="d-flex justify-content-center mb-2">
              <div className="alert alert-success" style={{ padding: '5px 15px' }}>
                <TranslatesContent contentKey="copied-to-clipboard-in-ballys-crypto" />
              </div>
            </div>
          )}

          {showSuccessMessage && (
            <div
              ref={statusMessageRef}
              className={showSuccessMessage.includes("failed") ? "success-message-error" : "success-message"}
            >
              {renderMaybeTranslated(showSuccessMessage)}
            </div>
          )}

          <div className="qrpaymentText d-flex justify-content-center mb-2 cashierLabels">
            <TranslatesContent contentKey="amount-min-usd-5000-max-usd-25000-in-ballys-crypto" />{" "}
          </div>
          <div
            className="qrpaymentText d-flex justify-content-center mb-2"
            style={{ fontSize: 12 }}
          >
            <TranslatesContent contentKey="warning-transfer-below-min-or-above-max-funds-lost-in-ballys-crypto" />{" "}
          </div>
      </div>
          
    {/* <div>
      <QRupiComponent
        isOpen={isModalOpen}
        onClose={closeModal}
        qrCodeValue={qrCodeUrl}
      />
    </div> */}
    </Fragment>
    
  );
};

export default BallysCryptoWallet;
